import React, { useState, useEffect, useContext } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { createMuiTheme, Slide, Container, Dialog, Toolbar, IconButton, Typography, Fab, CssBaseline, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { Context } from "../../contexts/siteContext";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import AddRoundListLocation from "../roundList/roundListLocationAdd";
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RoundListLocation(props) {
    const classes = useStyles();
    const roundListId = props.model.length === 0 ? 0 : props.model.RoundListId;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [addLocationOpen, setAddLocationOpen] = useState(false);
    const [roundListLocations, setRoundListLocations] = useState([]);
    const [id, setId] = useState();
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const getShortName = (name) => {
        if(name.indexOf("\\") === -1)
            return name;
        else
            return ".." + name.substring(name.indexOf("\\"));
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const addLocationClose = () => {
        setAddLocationOpen(false);
    };

    const roundListLocationClose = () => {
        props.parentCallback();
    };

    const addLocation = () => {
        setAddLocationOpen(true);
    };

    const deleteLocation = (id) => {
        setId(id);
        setConfirmOpen(true);
    };

    const deleteRoundListLocation = () => {
        setConfirmOpen(false);
        HttpService.post('/RoundList/DeleteRoundListLocation', { RoundListLocationId: id })
            .then((result) => {
                const data = roundListLocations.filter(roundListLocations => roundListLocations.RoundListLocationId !== id);
                setRoundListLocations(data);
            },
                (error) => {
                    console.log(error);
                });
    };

    const saveRoundListLocationDisplayOrder = (result) => {
        let displayOrders = [];
        for (let index = 0; index < result.length; index++) {
            displayOrders.push(result[index].RoundListLocationId);
        }
        HttpService.post('/RoundList/SaveRoundListLocationDisplayOrder', {
            LocationName: JSON.stringify(displayOrders),
            RoundList: roundListId
        })
            .then((result) => {
            },
                (error) => {
                    console.log(error);
                });
    };

    const getRoundListLocations = () => {
        setBackDrop(true);
        HttpService.post('/RoundList/GetRoundListLocations', {
            RoundListId: roundListId,
            SiteCode: defaultSite.id
        })
            .then((result) => {
                setRoundListLocations(result.data);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const handleDragEnd = (results) => {
        let tempdata = [...roundListLocations];
        if (results.destination !== null) {
            let [selectedRow] = tempdata.splice(results.source.index, 1);
            tempdata.splice(results.destination.index, 0, selectedRow);
            saveRoundListLocationDisplayOrder(tempdata);
            setRoundListLocations(tempdata);
        }
    };

    useEffect(() => {
        getRoundListLocations();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="locationBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={addLocationOpen} onClose={addLocationClose} TransitionComponent={Transition}>
                            <AddRoundListLocation parentCallback={addLocationClose}
                            refreshGrid={getRoundListLocations}
                            model={props.model}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={roundListLocationClose} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>Round List Locations</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addLocation}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table">
                                    <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
                                        <table className="table table-hover table-bordered">
                                            <thead>
                                                <tr>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Name</th>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}></th>
                                                </tr>
                                            </thead>
                                            <Droppable droppableId="tbody">
                                                {(provided) => (
                                                    <tbody ref={provided.innerRef} {...provided.droppableProps} className="text-capitalize">
                                                        {roundListLocations?.map((item, index) => (
                                                            <Draggable draggableId={item.RoundListLocationId.toString()} index={index} key={item.RoundListLocationId.toString()}>
                                                                {
                                                                    (provided, snapshot) => (
                                                                        <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                            <td style={rowStyle(index)} key={item.RoundListLocationId}>{index + 1}</td>
                                                                            <td style={rowStyle(index)}>{getShortName(item.LocationName)}</td>
                                                                            <td style={rowStyle(index)}>
                                                                                <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => deleteLocation(item.RoundListLocationId)} />
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </tbody>
                                                )}
                                            </Droppable>
                                        </table>
                                    </DragDropContext>
                                </div>
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteRoundListLocation}
                                    title="Delete Round List Location" message="Are you sure you want to delete the selected Round List Location?" />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }
    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
